import { User, Usuario } from '../@types';
import aqilaApi from './aqila-api';

class Usuarios {
  private readonly endpoint = 'v1/usuarios';

  async getById(id: number) {
    const { data } = await aqilaApi.get<User>(`${this.endpoint}/${id}`, {
      params: { all: true },
    });
    return data;
  }

  async listUsuariosAprovacao(propriedadeId: string) {
    const { data } = await aqilaApi.get<Usuario[]>(
      `${this.endpoint}/responsaveis_aprovacao_aplicacao`,
      {
        params: {
          propriedade: propriedadeId,
          tipo: 'pulverizacao',
        },
      },
    );
    return data;
  }
}

export default new Usuarios();
